import { Subject, Observable } from 'rxjs';

import { SnAlarm } from '@lib/api/entities';
import { SnSmartBadgeService } from '@lib/ui/badge';

export class SnAlarmsTracking {
  private readonly _alarmMap = new Map<string, SnAlarm>();

  private _alarmCount = 0;

  private readonly _alarmCreated$ = new Subject<SnAlarm>();
  private readonly _alarmUpdated$ = new Subject<SnAlarm>();
  private readonly _alarmRemoved$ = new Subject<SnAlarm>();

  constructor(private readonly _smartBadge: SnSmartBadgeService) {}

  get alarmCreated$(): Observable<SnAlarm> {
    return this._alarmCreated$.asObservable();
  }

  get alarmUpdated$(): Observable<SnAlarm> {
    return this._alarmUpdated$.asObservable();
  }

  get alarmRemoved$(): Observable<SnAlarm> {
    return this._alarmRemoved$.asObservable();
  }

  public addAlarm(data: any, autoplay: boolean = false, emitEvent: boolean = true): void {
    this._alarmCount++;
    this.setAlarmCount(this._alarmCount);
    const alarm = new SnAlarm(data);
    alarm.autoplay = autoplay;
    if (emitEvent) {
      this._alarmCreated$.next(alarm);
    }
  }

  public removeAlarm(data: any): void {
    const alarm = new SnAlarm(data);
    if (this._alarmCount > 0) {
      this._alarmCount--;
    }
    this.setAlarmCount(this._alarmCount);
    this._alarmRemoved$.next(alarm);
  }

  public hasAlarm(id: string): boolean {
    return this._alarmMap.has(id);
  }

  public updateAlarm(data: any): void {
    const alarm = new SnAlarm(data);
    this._alarmUpdated$.next(alarm);
  }

  public destroy(): void {
    this._alarmCreated$.complete();
    this._alarmUpdated$.complete();
    this._alarmRemoved$.complete();
  }

  public setAlarmCount(count: number): void {
    this._alarmCount = count;
    this._smartBadge.setBadge('live-tracking__alarm-count', this._alarmCount);
  }
}
